import { defineAsyncComponent, defineComponent } from 'vue';
export default defineComponent({
    components: {
        UiVideo: defineAsyncComponent(() => import(/* webpackChunkName: "Evolve-VideoComponent" */ '@app/components/UI/Video.vue')),
    },
    props: {
        uri: String
    }
});
